<template>
  <div class="invalid-feedback" v-if="message" v-text="message"></div>
</template>

<script>
export default {
  props: ['message'],
}
</script>
